import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { history } from '../../routes';
import config from '../../config';

import logo_negative from '../../assets/img/logo-negative.png';
import logo from '../../assets/img/logo.png';
import Button from '../commons/Button';
import ButtonIcon from '../commons/ButtonIcon';
import MenuItem from '../commons/MenuItem';

export default function Sidebar({ header }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [collapseShow, setCollapseShow] = React.useState("close");
  const user = useSelector(state => state.users.auth.user);

  const mainMenu = config.SIDEBAR.MENU.MAIN;
  const secondaryMenu = config.SIDEBAR.MENU.SECONDARY;
  const adminMenu = config.SIDEBAR.MENU.ADMIN;


  return (
    <nav className={"z-50 py-3 px-3 flex items-center h-16 " + (header && header.className ? header.className : "bg-primary text-primary-content")}>
      <div className="flex-no-wrap flex flex-wrap items-center justify-between w-full">
        <div className="">
          <ButtonIcon
            buttonClassName="btn-ghost btn-sm"
            className="w-6 h-6"
            onClick={() => setCollapseShow("open")}
            icon="menu"
          />
        </div>
        { header && header.title ? (
            <h2>{header.title}</h2>
          ) : header && header.logo && (
            <div className="mx-auto">
              <img src={logo_negative} alt="" width="100px" />
            </div>
          )
        }
        <div className="w-12">
          { header && header.right && (
            <ButtonIcon
              buttonClassName="btn-ghost btn-sm"
              className={header.right.className ? header.right.className : "h-6 w-6"}
              onClick={header.right.action}
              icon={header.right.icon}
            />
          )}
        </div>
        <div
          className={
            "bg-base-200 text-base-content z-50 transform top-0 left-0 bottom-0 w-64 fixed h-full overflow-auto ease-in-out transition-all duration-300 p-3 flex justify-between flex-col rounded-r-2xl bg-pattern "
            + (collapseShow === "close" ? "-translate-x-full" : "translate-x-0")
          }
        >
          <div className="md:min-w-full block pb-4 mb-4">
            <ButtonIcon
              buttonClassName="btn-ghost text-base-300 absolute left-0"
              className="w-8 h-8"
              onClick={() => setCollapseShow("close")}
              icon="close"
            />

            <div className="sidebar--user-nfo">
              <ButtonIcon
                buttonClassName="btn-ghost btn-sm text-base-300 absolute right-0 top-0"
                className="w-6 h-6"
                onClick={() => history.push(config.ROUTES.NOTIFICATIONS)}
                icon="bell"
              />
              <div className={"avatar " + (user.picture && user.picture.className ? user.picture.className : " w-12 h-12")
              }
                onClick={()=> { user.picture && user.picture.onClick && user.picture.onClick(); }}
              >
                {user.profile_image ? (
                  <img className="w-full h-auto" src={user.profile_image} alt="" />
                ) : (
                  <span className="m-auto text-2xl">{user.name}</span>
                )}
              </div>

              <div className="ml-3 mr-auto">
                <h4 className="">
                  {`${user.first_name} ${user.last_name}`}
                </h4>
                <p className="text-300">{user.insurance}</p>
                <Button
                  className="btn-primary btn-xs mx-auto mt-2"
                  title={t("Profile")}
                  onClick={() => history.push(config.ROUTES.USER.PROFILE)}
                />
              </div> 

              
            </div>

            <div className="flex flex-col md:flex-col md:min-w-full">
              { mainMenu && mainMenu.map((item, index) => <MenuItem key={index} item={item} location={location} />)}
            </div>
          </div>
          {/* <div className="flex flex-col md:flex-col md:min-w-full border-t text-sm border-solid border-white border-opacity-20 pt-4">
            { secondaryMenu && secondaryMenu.map((item, index) => <MenuItem key={index} item={item} location={location} />)}
          </div> */}
          <div className="absolute bottom-4 left-0 right-0">
            <img className="mx-auto" src={logo} alt="" width="180px" />
          </div>
        </div>
        <div className={"fixed inset-0 z-10 w-screen h-screen bg-black/25 md:hidden " + (collapseShow === "open" ? "" : "hidden")}></div>
      </div>
    </nav>
  );
}
